import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge only knows Tailwind's own font sizes; without these, a named
 * Brand 2.2 size (`text-2xs`) would be read as a text colour and dropped next
 * to `text-muted-foreground`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["2xs", "caption", "compact", "hero", "section", "closing"] },
      ],
      tracking: [{ tracking: ["label"] }],
      // Named preset values: without them `shadow-edge-start` reads as a
      // shadow colour and is dropped next to `shadow-domain-*-solid`, and a
      // named layer or width would not replace the component default.
      shadow: [{ shadow: ["edge-start"] }],
      z: [
        {
          z: [
            "ai-bubble",
            "sheet",
            "above-sheet",
            "popover",
            "floating",
            "toast",
            "header",
          ],
        },
      ],
      w: [{ w: ["popover-trigger"] }],
      "min-h": [{ "min-h": ["embedded-panel"] }],
      "max-w": [{ "max-w": ["embedded-panel"] }],
    },
  },
});

/**
 * Combines class names with tailwind-merge for proper class deduplication.
 * Use this for combining conditional classes in components.
 *
 * @param inputs - Class names to combine
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
